<div class="password-requirements" *ngIf="isVisible">
    <p class="requirements-text">
        {{ 'form.password_requirements' | translate }}
    </p>
</div>
